
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$drop-down.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$drop-down.js';
export default __default__;
